"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1088],{

/***/ 81088:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ injectedWallet_default; }
/* harmony export */ });
"use client";
// src/wallets/walletConnectors/injectedWallet/injectedWallet.svg
var injectedWallet_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMGgyOHYyOEgweiIvPjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIxNiIgeD0iNCIgeT0iNiIgZmlsbD0idXJsKCNhKSIgcng9IjMuNSIvPjxwYXRoIGZpbGw9IiMwRTc2RkQiIGQ9Ik0xNiAxNGEzIDMgMCAwIDEgMy0zaDQuNGMuNTYgMCAuODQgMCAxLjA1NC4xMDlhMSAxIDAgMCAxIC40MzcuNDM3QzI1IDExLjc2IDI1IDEyLjA0IDI1IDEyLjZ2Mi44YzAgLjU2IDAgLjg0LS4xMDkgMS4wNTRhMSAxIDAgMCAxLS40MzcuNDM3QzI0LjI0IDE3IDIzLjk2IDE3IDIzLjQgMTdIMTlhMyAzIDAgMCAxLTMtM1oiLz48Y2lyY2xlIGN4PSIxOSIgY3k9IjE0IiByPSIxLjI1IiBmaWxsPSIjQTNEN0ZGIi8+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iMTQiIHgyPSIxNCIgeTE9IjYiIHkyPSIyMiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIHN0b3AtY29sb3I9IiMxNzQyOTkiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMwMDFFNTkiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48L3N2Zz4=";



/***/ })

}]);